/**
 * Query for menu read endpoints when loading a menu into an editing surface:
 * every server-side fill-in is disabled so the form only shows — and later
 * re-saves — values the user actually entered. View surfaces should NOT use
 * this; they want the server-filled display names.
 */
export const rawMenuEditReadQuery = {
  aggregate_food_tags: false,
  fill_item_display_names: false,
  fill_latest_food_costs: false,
  fill_involved_foods: false,
} as const;

export default rawMenuEditReadQuery;
